/* eslint-disable key-spacing */
/* eslint-disable no-unused-vars */
/* eslint-disable no-undef */
/* eslint-disable global-require */
const plugin = require('tailwindcss/plugin');
const colors = Object.assign(require('tailwindcss/colors'), {
  primary: {
    50: '#e6f1f8',
    100: '#cce2f0',
    200: '#99c5e2',
    300: '#66a9d3',
    400: '#338cc5',
    500: '#006fb6',
    600: '#005992',
    700: '#00436d',
    800: '#002c49',
    900: '#001624',
  },
  secondary: {
    50: '#e6ebf0',
    100: '#ccd7e1',
    200: '#99afc3',
    300: '#6687a5',
    400: '#335f87',
    500: '#003769',
    600: '#002c54',
    700: '#00213f',
    800: '#00162a',
    900: '#000b15',
  },
});

delete colors.lightBlue;
delete colors.warmGray;
delete colors.trueGray;
delete colors.coolGray;
delete colors.blueGray;

if (process.env.NODE_ENV === 'staging') {
  colors.primary = colors.secondary;
}

module.exports = {
  content: [
    './resources/js/**/*.{js,ts,jsx,tsx}',
    './resources/views/**/*.blade.php',
    './plugins/**/resources/views/**/*.blade.php',
    './plugins/**/resources/js/**/*.{js,ts,jsx,tsx}',
    // './app/Models/*.php',
  ],
  theme: {
    colors: {
      transparent: 'transparent',
      current: 'currentColor',
      ...colors,
    },
    screens: {
      sm: '640px',
      md: '768px',
      mdmd: '900px',
      lg: '1024px',
      xl: '1280px',
    },
    extend: {
      backgroundImage: (theme) => ({
        sedan: "url('/images/cars/sedan.png')",
      }),
      spacing: {
        112: '28rem',
        128: '32rem',
        160: '40rem',
      },
      height: {
        112: '28rem',
        128: '32rem',
        160: '40rem',
      },
      rotate: {
        900: '-90deg',
      },
    },
  },
  plugins: [
    require('@tailwindcss/forms'),
    plugin(({ addVariant, e }) => {
      addVariant('invalid', ({ modifySelectors, separator }) => {
        modifySelectors(({ className }) => `.${e(`invalid${separator}${className}`)}:invalid`);
      });
    }),
  ],
};
